import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { GET_SELECTED_WORK_ORDER_OPERATION } from 'lib/api/queries';
import { getIsApmERPJobFlow } from 'lib/selectors/getIsApmERPJobFlow';

/**
 * The running job's full ERP work order operation. APM's currentWorkOrderOp
 * carries only a few of its fields; other flows already hold the full record,
 * so the query only runs in the APM flow. The change-job flow already fetches
 * this record (useSamePartOperationWorkOrderOps), so it's usually cached.
 */
const useCurrentWorkOrderOpRecord = ({
  workOrderOperationRef,
  skip = false,
} = {}) => {
  const isApmERPJobFlow = useSelector(getIsApmERPJobFlow);
  const skipQuery = skip || !isApmERPJobFlow || workOrderOperationRef == null;

  const { data, loading } = useQuery(GET_SELECTED_WORK_ORDER_OPERATION, {
    variables: { workOrderOperationRef },
    skip: skipQuery,
    fetchPolicy: 'cache-first',
  });

  return {
    currentWorkOrderOpRecord: skipQuery
      ? null
      : data?.erpWorkOrderOperation ?? null,
    loading: !skipQuery && loading && !data,
  };
};

export default useCurrentWorkOrderOpRecord;
